<aside
  class="sidebar"
  [class.public-access]="isPublicAccess()"
  [class.irrigator-access]="isIrrigatorAccess()"
  [class.guard-access]="isGuardAccess()"
  [class.manager-access]="isManagerAccess()"
>
  <nav class="side-menu" aria-label="Menu principal">
    @if (isIrrigatorAccess()) {
      <button
        class="side-menu-item"
        type="button"
        [class.active]="irrigatorParcelsPanelVisible"
        [attr.aria-expanded]="irrigatorParcelsPanelVisible"
        (click)="toggleIrrigatorParcelsPanel()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
        <span>Mis parcelas</span>
        <svg class="submenu-chevron" viewBox="0 0 24 24" aria-hidden="true">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
      @if (irrigatorParcelsPanelVisible) {
        <div class="parcel-submenu" role="group" aria-label="Parcelas del comunero">
          @if (irrigatorParcelsLoading) {
            <span class="parcel-submenu-status">Cargando parcelas...</span>
          } @else if (irrigatorParcelsError) {
            <span class="parcel-submenu-status error">{{ irrigatorParcelsError }}</span>
          } @else if (!irrigatorParcels.length) {
            <span class="parcel-submenu-status">Sin parcelas asociadas</span>
          } @else {
            @for (parcel of irrigatorParcels; track parcel.id) {
              <button
                class="parcel-submenu-item"
                type="button"
                [class.active]="parcel.id === selectedIrrigatorParcelId"
                (click)="selectIrrigatorParcel(parcel)"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M6 5.5 15.5 3l4 7.5-3.5 8-9 2.5-4.5-7.5L6 5.5Z" />
                  <path d="M6 5.5 16 18.5" />
                  <path d="M15.5 3 16 18.5" />
                </svg>
                <span>{{ parcel.cadastralReference }}</span>
              </button>
            }
          }
        </div>
      }
      <button class="side-menu-item" type="button">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3c2.8 3.3 4.2 6 4.2 8.2a4.2 4.2 0 1 1-8.4 0C7.8 9 9.2 6.3 12 3Z" />
          <path d="M12 14.8v-4" />
        </svg>
        <span>Información de riego</span>
      </button>
    } @else if (isManagerAccess()) {
      <button
        class="side-menu-item active"
        type="button"
        (click)="showGuardFieldOperations(null)"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3V6Z" />
          <path d="M9 3v15" />
          <path d="M15 6v15" />
        </svg>
        <span>Mapa</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="incidentsSummaryVisible"
        (click)="showGuardFieldOperations('incidents')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3 2.8 19h18.4L12 3Z" />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </svg>
        <span>Incidencias</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="maintenanceSummaryVisible"
        (click)="showGuardFieldOperations('maintenance')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 4h14v16H5z" />
          <path d="M8 8h8M8 12h8M8 16h5" />
        </svg>
        <span>Escuras</span>
      </button>
    } @else if (isGuardAccess()) {
      <button
        class="side-menu-item"
        [class.active]="guardFieldOperationsView === null"
        type="button"
        (click)="showGuardFieldOperations(null)"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3V6Z" />
          <path d="M9 3v15" />
          <path d="M15 6v15" />
        </svg>
        <span>Mapa</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="guardTakesPanelVisible"
        [attr.aria-expanded]="guardTakesPanelVisible"
        (click)="toggleGuardTakesPanel()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 12c3-5 8-5 11-2" />
          <path d="M13 5h6v6" />
          <path d="M19 5 12 12" />
        </svg>
        <span>Mis tomas</span>
        <svg class="submenu-chevron" viewBox="0 0 24 24" aria-hidden="true">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
      @if (guardTakesPanelVisible) {
        <div class="parcel-submenu guard-takes-submenu" role="group" aria-label="Tomas del guarda">
          @if (guardTakesLoading) {
            <span class="parcel-submenu-status">Cargando tomas...</span>
          } @else if (guardTakesError) {
            <span class="parcel-submenu-status error">{{ guardTakesError }}</span>
          } @else if (!guardTakes.length) {
            <span class="parcel-submenu-status">Sin tomas asociadas</span>
          } @else {
            @for (take of guardTakes; track take.id) {
              <button
                class="parcel-submenu-item"
                type="button"
                [class.active]="take.id === selectedGuardTakeId"
                (click)="selectGuardTake(take)"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M5 12c3-5 8-5 11-2" />
                  <path d="M13 5h6v6" />
                  <path d="M19 5 12 12" />
                </svg>
                <span>{{ take.label }}</span>
              </button>
            }
          }
        </div>
      }
      <button
        class="side-menu-item"
        type="button"
        [class.active]="incidentsSummaryVisible"
        (click)="showGuardFieldOperations('incidents')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3 2.8 19h18.4L12 3Z" />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </svg>
        <span>Avisos e incidencias</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="maintenanceSummaryVisible"
        (click)="showGuardFieldOperations('maintenance')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 4h14v16H5z" />
          <path d="M8 8h8M8 12h8M8 16h5" />
        </svg>
        <span>Escuras</span>
      </button>
    } @else {
      <button class="side-menu-item active" type="button">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3V6Z" />
          <path d="M9 3v15" />
          <path d="M15 6v15" />
        </svg>
        <span>Mapa</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="publicInfoVisible"
        [attr.aria-expanded]="publicInfoVisible"
        (click)="toggleInformation()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v6" />
          <path d="M12 7h.01" />
        </svg>
        <span>Información</span>
      </button>
      <button
        class="side-menu-item"
        type="button"
        [class.active]="aboutRamVisible"
        [attr.aria-expanded]="aboutRamVisible"
        (click)="showAbout()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 22c2.8-4.5 4.2-8.1 4.2-10.8 0-3.2-1.5-6-4.2-8.2-2.7 2.2-4.2 5-4.2 8.2C7.8 13.9 9.2 17.5 12 22Z" />
          <path d="M12 22V8" />
          <path d="M12 14c-2.4-.2-4.3-1.2-5.7-3" />
          <path d="M12 17c2.4-.2 4.3-1.2 5.7-3" />
        </svg>
        <span>Acerca de RAM</span>
      </button>
    }
  </nav>

  @if (!isPublicAccess()) {
    <button class="side-menu-item logout" type="button" (click)="logout($event)">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M10 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2" />
        <path d="M15 17l5-5-5-5" />
        <path d="M20 12H8" />
      </svg>
      <span>Cerrar sesión</span>
    </button>
  }
</aside>
